import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { getIdByChequeApi } from "../../../apiservice/accounts";
import { getInstitutionApi } from "../../../apiservice/setting";
import { numberFormat, convertNumberToWords } from "../../../lib/functions";
import "./chequeVoucher.css";

const fmt = (d) => (d ? dayjs(d).format("DD/MM/YYYY") : "-");

const ChequeVoucherBody = ({ chequeId, printMode = false }) => {
  const [data, setData] = useState(null);
  const [institution, setInstitution] = useState(null);

  useEffect(() => {
    if (!chequeId) return;
    setData(null);

    getIdByChequeApi({ id: chequeId })
      .then((res) => {
        const row = res?.data?.[0];
        if (!row) return;
        setData({
          ...row,
          invoice_date: row.created_date,
          cheque_type: row.acc_name,
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: "warning",
          title:
            err.response?.data?.message ||
            "Internal Error: If the issue persists, please contact support.",
          confirmButtonColor: "#1677ff",
        });
      });

    getInstitutionApi()
      .then((res) => setInstitution(res.data))
      .catch(() => setInstitution(null));
  }, [chequeId]);

  if (!data) {
    return (
      <div className="cv-loading">
        <Spin />
      </div>
    );
  }

  const currency = institution?.currency || "";

  return (
    <div className="cheque-voucher">
      <div className="cv-letterhead">
        <div className="cv-company-name">{institution?.name || "-"}</div>
        {(institution?.phone_no || institution?.street_address) && (
          <div className="cv-company-contact">
            {institution?.phone_no && <>TEL : {institution.phone_no}</>}
            {institution?.phone_no && institution?.street_address && ". "}
            {institution?.street_address}
          </div>
        )}
      </div>

      <div className="cv-box">
        <div className="cv-no-date">
          <div>
            <strong>No:</strong> {data.voucher_no || "-"}
          </div>
          <div>
            <strong>Date:</strong> {fmt(data.date)}
          </div>
        </div>

        <div className="cv-to">
          <div>To</div>
          <div>Mr./Messrs.: {data.from_acc || "-"}</div>
        </div>

        <div className="cv-body-text">
          <p>Sir,</p>
          <p>
            Please find the enclosed cheque bearing No.{" "}
            <strong>{data.cheque_number || "-"}</strong> dated {fmt(data.date)}{" "}
            for {currency} <strong>{numberFormat(data.amount)}</strong> (
            {convertNumberToWords(data.amount, institution?.currency)} )
            which is against the following Bill(s)
          </p>
          <p>Kindly acknowledge the same and send your official receipt.</p>
        </div>

        <table className="cv-bill-table">
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{data.voucher_no || "-"}</td>
              <td>{fmt(data.invoice_date)}</td>
              <td>{numberFormat(data.amount)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="cv-footer">
        {data.narration && (
          <div className="cv-narration">
            <strong>Narration</strong> {data.narration}
          </div>
        )}

        <div className="cv-signature-row">
          <span className="cv-sign-item">
            Prepared By<span className="cv-dots" />
          </span>
          <span className="cv-sign-item">
            Passed By<span className="cv-dots" />
          </span>
          <span className="cv-sign-item">
            Approved By<span className="cv-dots" />
          </span>
        </div>
        <div className="cv-signature-row cv-signature-row-end">
          <span className="cv-sign-item">
            Received By<span className="cv-dots" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChequeVoucherBody;
